/* ============================================================
   Партнёры и спонсоры + CTA «Станьте партнёром» (модалка).
   ============================================================ */
import { useFedStore, useL } from '../store';
import { useFedContent, uploadUrl } from '../content';
import { Ic } from '../icons';
import { Rv, PageHead } from '../ui';

export default function FedPartners() {
  const { lang, openSponsor } = useFedStore();
  const L = useL();
  const partners = useFedContent((s) => s.partners);

  return (
    <div className="fed-pagewrap max-w-[1320px] mx-auto" style={{ padding: '52px 24px 72px' }}>
      <PageHead eyebrow={L.partnersEyebrow} title={L.pt_h1} sub={L.pt_sub} mb={32} />

      <div className="grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', marginBottom: 44 }}>
        {partners.map((p, i) => (
          <Rv key={p.id || p.name} delay={(i % 3) * 0.06} className="flex items-center gap-4 rounded-2xl border border-line" style={{ padding: 22, background: 'linear-gradient(160deg,var(--fed-surface-2),var(--fed-surface))' }}>
            <div className="flex-shrink-0 flex items-center justify-center rounded-[14px] font-display font-bold text-white overflow-hidden" style={{ width: 60, height: 60, fontSize: 20, background: p.logo ? 'var(--fed-surface-3)' : p.badge }}>
              {p.logo ? <img src={uploadUrl(p.logo)} alt="" className="w-full h-full" style={{ objectFit: 'cover' }} /> : p.mono}
            </div>
            <div className="min-w-0">
              <div className="font-display font-semibold text-fg" style={{ fontSize: 18 }}>{p.name}</div>
              <div className="text-fg-muted" style={{ fontSize: 13, marginTop: 3 }}>{p['role_' + lang]}</div>
            </div>
          </Rv>
        ))}
      </div>

      <Rv
        className="relative overflow-hidden rounded-[20px] text-center shadow-card-lg"
        style={{ padding: '44px 36px', background: 'linear-gradient(130deg,rgba(230,183,60,.16),rgba(225,18,23,.1) 60%,var(--fed-surface))', border: '1px solid rgba(230,183,60,.4)' }}
      >
        <h2 className="max-w-[640px] mx-auto" style={{ fontSize: 'clamp(26px,4vw,40px)' }}>{L.pt_become_t}</h2>
        <p className="max-w-[520px] mx-auto text-fg-soft" style={{ marginTop: 14, fontSize: 15.5, lineHeight: 1.6 }}>{L.pt_become}</p>
        <button onClick={openSponsor} className="fed-btn-primary h-[52px] px-7 gap-2.5" style={{ marginTop: 24, fontSize: 16 }}>
          <Ic name="zap" size={17} sw={2.2} />
          {L.sp_btn}
        </button>
      </Rv>
    </div>
  );
}
